import { render, staticRenderFns } from "./addPurchaseApplyList.vue?vue&type=template&id=0967b276&scoped=true"
import script from "./addPurchaseApplyList.vue?vue&type=script&lang=js"
export * from "./addPurchaseApplyList.vue?vue&type=script&lang=js"
import style0 from "./addPurchaseApplyList.vue?vue&type=style&index=0&id=0967b276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0967b276",
  null
  
)

export default component.exports